import { Languages } from 'lucide-react';

import { getAppLanguageOptions } from '@/lib/app-locale-change';
import type { CommandDef } from './types';

export const CHANGE_LANGUAGE_COMMAND_ID = 'change-language';

/**
 * "Change language" quick action: opens a static picker listing every app
 * language by its native name, with the current one checked.
 */
export function buildChangeLanguageCommand({
  label,
  placeholder,
  currentLocale,
  onSelectLocale,
}: {
  label: string;
  placeholder: string;
  currentLocale: string;
  onSelectLocale: (locale: string) => void | Promise<void>;
}): CommandDef {
  const options = getAppLanguageOptions(currentLocale);
  return {
    id: CHANGE_LANGUAGE_COMMAND_ID,
    label,
    icon: Languages,
    // Lets "日本語", "japanese" or "language" find the command from the root.
    keywords: [
      'language',
      'locale',
      'translate',
      ...options.flatMap((option) => [
        option.nativeLabel.toLowerCase(),
        option.englishLabel.toLowerCase(),
      ]),
    ],
    subPage: {
      type: 'static',
      placeholder,
      items: options.map((option) => ({
        id: option.locale,
        label: option.nativeLabel,
        lang: option.locale,
        hint:
          option.englishLabel === option.nativeLabel
            ? undefined
            : option.englishLabel,
        keywords: [option.locale.toLowerCase()],
        selected: option.isCurrent,
        onSelect: () => onSelectLocale(option.locale),
      })),
    },
  };
}
